export function setSwCta(search: string = window.location.search): void {
  const swCta = new URLSearchParams(search).get('sw_cta');
  if (!swCta) return;
  localStorage.setItem('sw_cta', swCta);
}

export function getSwCta(): string | null {
  return localStorage.getItem('sw_cta');
}
